import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import classes from '../../asset/css/shipping-address/address.module.css';
import goAndBackClasses from '../../asset/css/go-and-back.module.css';
import { ShippingAddressType } from '../../types/shipping-address-type';

export const Address: FC<{ shippingAddress?: ShippingAddressType }> = ({ shippingAddress }) => {
  let addressHtml = <></>;
  if (shippingAddress) {
    addressHtml = (
      <p>
        {shippingAddress.lastName} {shippingAddress.firstName}
        <br />
        {shippingAddress.zip}
        <br />
        {shippingAddress.country.zones.find((zone) => zone.code === shippingAddress.provinceCode)!.name}{' '}
        {shippingAddress.city}
        <br />
        {shippingAddress.address1} {shippingAddress.address2}
        <br />
        {shippingAddress.country.name}
      </p>
    );
  }

  return (
    <>
      <div className={classes.mypage_subsc_address}>
        <h2>毎月お届けプランのお届け先変更</h2>
        <h3>毎月お届けプランのお届け先住所</h3>
        {addressHtml}
      </div>
      <div className={goAndBackClasses.mypage_subsc_go_and_back_buttons}>
        <Link to="/shippingAddress/form">変更する</Link>
        <Link to="/">もどる</Link>
      </div>
    </>
  );
};
